import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout";
import MusicPlayerPage from "./pages/music-player";
import NotFound from "./pages/notFound";
import VideoPlayerPage from "./pages/video-player";

function App() {
  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/radio-online/music-player" replace />} />
        <Route path="/radio-online/music-player" element={<MusicPlayerPage />} />
        <Route path="/radio-online/video-player" element={<VideoPlayerPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
